import { render, staticRenderFns } from "./sb-farm-page.vue?vue&type=template&id=7e70f52a&scoped=true&"
import script from "./sb-farm-page.vue?vue&type=script&lang=ts&"
export * from "./sb-farm-page.vue?vue&type=script&lang=ts&"
import style0 from "./sb-farm-page.vue?vue&type=style&index=0&id=7e70f52a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e70f52a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
